import { render } from "./add-strategy.vue?vue&type=template&id=22be04df&scoped=true"
import script from "./add-strategy.vue?vue&type=script&lang=js"
export * from "./add-strategy.vue?vue&type=script&lang=js"

import "./add-strategy.vue?vue&type=style&index=0&id=22be04df&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22be04df"]])

export default __exports__